function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.5598 1.24703L4.55977 8.24703C4.51914 8.28771 4.47089 8.31998 4.41778 8.34199C4.36467 8.36401 4.30774 8.37534 4.25024 8.37534C4.19275 8.37534 4.13582 8.36401 4.08271 8.34199C4.0296 8.31998 3.98134 8.28771 3.94071 8.24703L0.878212 5.18453C0.796119 5.10244 0.75 4.9911 0.75 4.875C0.75 4.7589 0.796119 4.64756 0.878212 4.56547C0.960305 4.48337 1.07165 4.43726 1.18774 4.43726C1.30384 4.43726 1.41518 4.48337 1.49727 4.56547L4.25024 7.31898L10.9407 0.627968C11.0228 0.545875 11.1341 0.499756 11.2502 0.499756C11.3663 0.499756 11.4777 0.545875 11.5598 0.627968C11.6419 0.71006 11.688 0.821402 11.688 0.937499C11.688 1.0536 11.6419 1.16494 11.5598 1.24703Z",
    fill: "#10B0C6",
    style: {
      fill: "#10B0C6",
      fill: "color(display-p3 0.0614 0.6894 0.7751)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneIcon);
export default __webpack_public_path__ + "static/media/doneIcon.f6b5f39b30835f46f979e5579ca9727e.svg";
export { ForwardRef as ReactComponent };